

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GoogleMap, Marker, useLoadScript, Autocomplete, } from "@react-google-maps/api";
import { FaAddressCard, FaCreditCard, FaMapMarkerAlt } from "react-icons/fa";
import { AiFillHome, AiFillTool } from "react-icons/ai";
import { FaEdit } from "react-icons/fa";
import { MdWork } from "react-icons/md";

const mapContainerStyle = {
  width: "100%",
  height: "320px",
  borderRadius: "12px",
  marginBottom: "15px",
};

const defaultCenter = { lat: 20.5937, lng: 78.9629 };

const Checkout = () => {
  const navigate = useNavigate();

  const savedUser = JSON.parse(sessionStorage.getItem("userData")) || {};
  const savedAddress =
    JSON.parse(sessionStorage.getItem("checkoutAddress")) || null;
  const cartItems = JSON.parse(sessionStorage.getItem("checkoutCart")) || [];
  const totals =
    JSON.parse(sessionStorage.getItem("checkoutTotals")) || {
      subtotal: 0,
      savings: 0,
    };

  const [savedUserId] = useState(sessionStorage.getItem("userId") || null);
  const [userAddresses, setUserAddresses] = useState([]);
  const [selectedAddrId, setSelectedAddrId] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const userId = savedUserId;
    if (!userId) return;

    const fetchAddresses = async () => {
      try {
        const res = await fetch(`https://api.glocart.in/payment/api/api/addresses?user_id=${userId}`);
        const data = await res.json();
        setUserAddresses(data);

        // Set default address from DB if none already saved
        if (!savedAddress && data.length > 0) {
          const first = data[0];
          setAddress((prev) => ({
            ...prev,
            house: first.line1,
            landmark: first.line2 || "",
            city: first.city,
            pincode: first.zip,
          }));
          setSelectedAddrId(first.id);
        }
      } catch (err) {
        console.error("Error fetching user addresses:", err);
      }
    };

    fetchAddresses();
  }, []);





  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
    @media (max-width: 992px) {
      .checkout-container {
        flex-direction: column;
      }
      .left-panel, .right-panel {
        width: 100% !important;
      }
      .order-summary {
        margin-top: 20px;
      }
    }

    @media (max-width: 768px) {
      .stepper {
        flex-direction: column;
        gap: 8px;
        text-align: center;
      }
      .stepper span {
        font-size: 15px;
      }
    }

    @media (max-width: 480px) {
      input, button {
        font-size: 14px !important;
        padding: 10px !important;
      }
      .stepper {
        font-size: 14px !important;
      }
    }
  `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);


  const [shippingCharges, setShippingCharges] = useState({ domestic: 0, nonDomestic: 0 });
  const [step, setStep] = useState("location"); // location → details → payment
  const [address, setAddress] = useState(
    savedAddress || {
      firstName: savedUser.firstName || "",
      lastName: savedUser.lastName || "",
      email: savedUser.email || "",
      mobile: savedUser.mobile || "",
      house: "",
      landmark: "",
      city: "",
      pincode: "",
      addressType: "home",
      lat: defaultCenter.lat,
      lng: defaultCenter.lng,
    }
  );

  const [autocomplete, setAutocomplete] = useState(null);

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyAskOLVxenXFbWP4Z-kTOJnzaC-p7a5fBM",
    libraries: ["places"],
  });





  useEffect(() => {
    if (!savedAddress) {
      navigator.geolocation.getCurrentPosition((pos) => {
        setAddress((prev) => ({
          ...prev,
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        }));
      });
    }
  }, [savedAddress]);

  const onPlaceChanged = () => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();
      if (place.geometry) {
        setAddress((prev) => ({
          ...prev,
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
          city:
            place.address_components?.find((c) =>
              c.types.includes("locality")
            )?.long_name || prev.city,
          pincode:
            place.address_components?.find((c) =>
              c.types.includes("postal_code")
            )?.long_name || prev.pincode,
        }));
      }
    }
  };



  const fetchShippingCharges = async () => {
    try {
      const res = await fetch('https://api.glocart.in/payment/api/api/getShippingCharges');
      const data = await res.json();

      // Assuming the labels are 'Domestic' and 'Non-Domestic'
      const domesticCharge = data.find(charge => charge.label === 'Domestic')?.value || 0;
      const nonDomesticCharge = data.find(charge => charge.label === 'Non-Domestic')?.value || 0;

      setShippingCharges({ domestic: domesticCharge, nonDomestic: nonDomesticCharge });
    } catch (err) {
      console.error('Error fetching shipping charges:', err);
    }
  };

  // Call this function on component mount to load the shipping charges


  useEffect(() => {
    fetchShippingCharges();
  }, []);

  const handleSaveDetails = async () => {
     if (!address.mobile || address.mobile.length !== 10) {
    alert("Please enter a valid 10-digit mobile number");
    return;
  }
    sessionStorage.setItem("checkoutAddress", JSON.stringify(address));
    console.log("cartItemsCe", cartItems)

    const user_id = savedUser.id || 0; // ensure `id` exists in userData

    const payload = {
      user_id,
      address,
      is_paid: 0,
      status: "pending",
      totals: {
        subtotal: totals.subtotal,
        savings: totals.savings,
        shippingCharge: shippingCharge,

        grandTotal: grandTotal,
      },
      cartItems: cartItems.map((item) => {
        if (!item) {
          console.log("Item is undefined or null");
        }
        console.log(item);  // Log item here (side effect before returning the object)
        return {
          product_id: item.productId,
          v_id: item.variantId,
          name: item.name,
          quantity: item.quantity,
          price: item.price,
          weight: parseFloat(item.weight || 1),
        };
      }),
    };

    try {
      const res = await fetch("https://api.glocart.in/pages/api/checkout/init", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      console.log("Checkout initialized:", data);

      // Continue to payment step
      setStep("payment");
    } catch (err) {
      console.error("Error saving checkout:", err);
      alert("Something went wrong while saving your checkout.");
    }
  };

  const steps = [
    { label: "Location", icon: <FaMapMarkerAlt /> },
    { label: "Delivery Details", icon: <FaAddressCard /> },
    { label: "Payment", icon: <FaCreditCard /> },
  ];

  // const handlePlaceOrder = async () => {
  //   const payload = {
  //     amount: 1,
  //     firstname: address.firstName,
  //     email: address.email,
  //     phone: address.mobile,
  //     productinfo: "Your Order Description",
  //   };

  //   try {
  //     const res = await fetch("https://api.glocart.in/payment/api/initiate-payment", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify(payload),
  //     });

  //     const html = await res.text();  // <-- read as text, NOT JSON

  //     // Inject the form into the DOM and auto-submit
  //     const formDiv = document.createElement("div");
  //     formDiv.innerHTML = html;
  //     document.body.appendChild(formDiv);
  //     document.forms[0].submit();

  //   } catch (error) {
  //     console.error("Payment initiation failed", error);
  //   }
  // };


  const handlePlaceOrder = async () => {
    const user_id = savedUser?.id || 0;

    const payload = {
      user_id,
      address,
      totals: {
        subtotal: totals.subtotal,
        savings: totals.savings,
        shippingCharge: shippingCharge,
        grandTotal: grandTotal,
      },
      cartItems: cartItems.map((item) => {
        console.log(item);  // Log item here (side effect before returning the object)
        return {
          product_id: item.productId,
          v_id: item.variantId,
          name: item.name,
          quantity: item.quantity,
          price: item.price,
          weight: parseFloat(item.weight || 1),
        };
      }),
      amount: 1, // amount for payment gateway
      firstname: address.firstName,
      email: address.email,
      phone: address.mobile,
      productinfo: "GloCart Order", // Customize as needed
    };

    try {
      const res = await fetch("https://api.glocart.in/payment/api/initiate-payment", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const html = await res.text(); // HTML form from backend

      const formDiv = document.createElement("div");
      formDiv.innerHTML = html;
      document.body.appendChild(formDiv);

      document.forms[0].submit(); // Submit to PayU
    } catch (error) {
      console.error("Payment initiation failed:", error);
      alert("There was an issue initiating the payment.");
    }
  };



  if (!isLoaded) return <p>Loading map...</p>;



  // Calculate total weight from cart items
  // const getTotalWeight = () => {
  //   return cartItems.reduce((total, item) => {
  //     const weight = parseFloat(item.weight || 1); // default 1kg if not specified
  //     const quantity = parseInt(item.quantity || 1);
  //     return total + weight * quantity;
  //   }, 0);
  // };

  // Helper to get total weight
  // Helper: Get total cart weight
  // ✅ Helper: Get total cart weight
  const getTotalWeight = () => {
    return cartItems.reduce((total, item) => {
      const weight = parseFloat(item.unitValue || 1); // default 1 kg
      const quantity = parseInt(item.quantity || 1, 10);

      // Round UP fractional weight (e.g. 2.5 → 3)
      const roundedWeight = Math.ceil(weight);

      return total + roundedWeight * quantity;
    }, 0);
  };






  // ✅ Helper: Calculate shipping charge
  const getShippingCharge = () => {
    const totalWeight = getTotalWeight();
    if (totalWeight <= 0) return 0;

    // Normalize city input
    const city = (address.city || "").toLowerCase();

    // ✅ Hyderabad & Secunderabad → 70/kg
    const isDomestic = city === "hyderabad" || city === "secunderabad"; // Or based on your logic

    // Use dynamic shipping charges fetched from the API
    const shippingRatePerKg = isDomestic ? shippingCharges.domestic : shippingCharges.nonDomestic;


    return totalWeight * shippingRatePerKg;
  };

  // ✅ Final shipping charge
  const shippingCharge = getShippingCharge();

  console.log("Total Weight (kg):", getTotalWeight());
  console.log("Shipping Charge (₹):", shippingCharge);


  // Determine location charge based on pincode or city (you can customize this logic)
  const isOutstation = address.city?.toLowerCase() !== "yourlocalcity"; // <-- Replace 'yourlocalcity'
  const locationCharge = isOutstation ? 150 : 0;

  // Final total
  const grandTotal = totals.subtotal + shippingCharge;




  return (
    <div style={{ padding: "30px", maxWidth: "1300px", margin: "0 auto" }}>
      {/* Stepper */}
      <div
        className="stepper"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "30px",
          padding: "16px 24px",
          borderRadius: "14px",
          background: "linear-gradient(135deg, #0357a0, #0357a0)",
          color: "white",
          fontWeight: "600",
          letterSpacing: "0.7px",
          boxShadow: "0 6px 15px rgba(0,0,0,0.1)",
        }}
      >
        {steps.map((s, index) => {
          const isActive = step === s.label.toLowerCase().replace(" ", "");
          return (
            <div
              key={s.label}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                flex: 1,
                opacity: isActive ? 1 : 0.5,
                transition: "opacity 0.3s ease",
              }}
            >
              <div
                style={{
                  fontSize: "22px",
                  marginBottom: "6px",
                  color: isActive ? "#fff" : "#eee",
                }}
              >
                {s.icon}
              </div>
              <span style={{ fontSize: "15px" }}>{`${index + 1}. ${s.label}`}</span>
            </div>
          );
        })}
      </div>

      <div className="checkout-container" style={{ display: "flex", gap: "25px", flexWrap: "wrap" }}>

        {/* Left Panel */}
        <div
          className="left-panel"
          style={{
            flex: 2,
            background: "#fff",
            padding: "25px",
            borderRadius: "12px",
            boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
            minWidth: "0", // helps on narrow screens
          }}
        >

          {/* Step 1: Location */}
          {step === "location" && (
            <>
              <h3 style={{ marginBottom: "15px", color: "#4B0082" }}>
                Select Location
              </h3>
              <Autocomplete
                onLoad={(ac) => setAutocomplete(ac)}
                onPlaceChanged={onPlaceChanged}
              >
                <input
                  type="text"
                  placeholder="Search your location..."
                  style={{
                    width: "100%",
                    padding: "12px",
                    borderRadius: "8px",
                    border: "1px solid #ccc",
                    marginBottom: "15px",
                  }}
                />
              </Autocomplete>

              <GoogleMap
                mapContainerStyle={mapContainerStyle}
                zoom={15}
                center={{ lat: address.lat, lng: address.lng }}
              >
                <Marker
                  position={{ lat: address.lat, lng: address.lng }}
                  draggable={true}
                  onDragEnd={(e) =>
                    setAddress((prev) => ({
                      ...prev,
                      lat: e.latLng.lat(),
                      lng: e.latLng.lng(),
                    }))
                  }
                />
              </GoogleMap>

              <button
                onClick={() => setStep("details")}
                style={{
                  marginTop: "15px",
                  width: "100%",
                  padding: "14px",
                  border: "none",
                  borderRadius: "8px",
                  background: "#0357a0",
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: "16px",
                }}
              >
                Continue
              </button>
            </>
          )}



          {/* Step 2: Delivery Details */}
          {step === "details" && (
            <>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                <h3 style={{ color: "#ffffffff" }}>Delivery Details</h3>
                <button
                  onClick={() => setIsModalOpen(true)}
                  style={{
                    background: "transparent",
                    border: "none",
                    color: "#0357a0",
                    fontWeight: "bold",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    fontSize: "14px"
                  }}
                >
                  <FaEdit style={{ marginRight: "5px" }} />
                  Change
                </button>
              </div>

              <div style={{ display: "grid", gap: "14px" }}>
                {[
                  { placeholder: "First Name", key: "firstName" },
                  { placeholder: "Last Name", key: "lastName" },
                  { placeholder: "Email", key: "email" },
                  { placeholder: "Mobile", key: "mobile", isMobile: true },
                  { placeholder: "House / Flat No", key: "house" },
                  { placeholder: "Landmark", key: "landmark" },
                  { placeholder: "City", key: "city" },
                  { placeholder: "Pincode", key: "pincode" },
                ].map((field) => (
                  <input
                    key={field.key}
                    placeholder={field.placeholder}
                    value={address[field.key]}
                    maxLength={field.isMobile ? 10 : undefined}
                    onChange={(e) => {
                      let value = e.target.value;
                      // ✅ Mobile number validation
                      if (field.isMobile) {
                        value = value.replace(/\D/g, ""); // allow only digits
                        if (value.length > 10) return;
                      }

                      setAddress({ ...address, [field.key]: e.target.value })
                    }}
                    style={{
                      padding: "12px 15px",
                      borderRadius: "8px",
                      border: "1px solid #ccc",
                      fontSize: "15px",
                      outline: "none",
                      boxShadow: "0 1px 4px rgba(0, 0, 0, 0.05)",
                      transition: "border-color 0.3s, box-shadow 0.3s",
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#0357a0";
                      e.target.style.boxShadow = "0 0 5px rgba(166, 20, 30, 0.3)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#ccc";
                      e.target.style.boxShadow = "0 1px 4px rgba(0, 0, 0, 0.05)";
                    }}
                  />
                ))}
              </div>
              <div style={{ margin: "10px 0", marginTop: '20px' }}>
                <button
                  type="button"
                  onClick={() => setAddress((a) => ({ ...a, addressType: "home" }))}
                  style={{
                    background: address.addressType === "home" ? "#0357a0" : "#eee",
                    color: address.addressType === "home" ? "#fff" : "#555",
                    marginRight: "8px",
                    padding: "5px",
                    borderRadius: '8px'
                  }}
                >
                  <AiFillHome size={20} color={address.addressType === "home" ? "#fff" : "#555"} />
                  Home
                </button>
                <button
                  type="button"
                  onClick={() => setAddress((a) => ({ ...a, addressType: "work" }))}
                  style={{
                    background: address.addressType === "work" ? "#0357a0" : "#eee",
                    color: address.addressType === "work" ? "#fff" : "#555",
                    padding: "5px",
                    borderRadius: '8px'
                  }}
                >
                  <MdWork size={20} color={address.addressType === "work" ? "#fff" : "#555"} />
                  Work
                </button>
              </div>

              <button
                onClick={handleSaveDetails}
                style={{
                  marginTop: "20px",
                  width: "100%",
                  padding: "14px",
                  border: "none",
                  borderRadius: "8px",
                  background: "#0357a0",
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: "16px",
                }}
              >
                Save & Continue
              </button>
            </>
          )}

          {/* Step 3: Payment */}
          {step === "payment" && (
            <>
              <h3 style={{ marginBottom: "15px", color: "#4B0082" }}>
                Payment Options
              </h3>

              <div
                style={{
                  marginBottom: "20px",
                  padding: "15px",
                  border: "1px solid #ddd",
                  borderRadius: "10px",
                  background: "#fafafa",
                }}
              >
                <h4>Deliver to:</h4>
                <p>
                  <strong>
                    {address.firstName} {address.lastName}
                  </strong>
                </p>
                <p>
                  {address.house}, {address.landmark}, {address.city} -{" "}
                  {address.pincode}
                </p>
                <p>Email: {address.email}</p>
                <p>Mobile: {address.mobile}</p>
              </div>


              <button
                onClick={handlePlaceOrder}
                style={{
                  width: "100%",
                  padding: "14px",
                  border: "none",
                  borderRadius: "8px",
                  background: "#0357a0",
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: "16px",
                }}
              >
                Place Order
              </button>
            </>
          )}
        </div>

        {/* Right Panel: Order Summary */}
        <div
          className="right-panel order-summary"
          style={{
            flex: 1,
            background: "#fff",
            padding: "20px",
            borderRadius: "12px",
            boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
            height: "fit-content",
            minWidth: "280px",
          }}
        >

          <h3 style={{ marginBottom: "15px", color: "#4B0082" }}>Order Summary</h3>
          {cartItems.map((item) => (
            <div key={item.id} style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}>
              <span>{item.name} × {item.quantity}</span>
              <span>₹{(item.price * item.quantity).toFixed(0)}</span>
            </div>
          ))}
          <hr />
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <strong>Subtotal:</strong>
            <span>₹{totals.subtotal.toFixed(0)}</span>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", color: "green" }}>
            <strong>Savings:</strong>
            <span>₹{totals.savings.toFixed(0)}</span>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <strong>Shipping Charges:</strong>
            <span>₹{shippingCharge.toFixed(0)}</span>
          </div>
          <small style={{ fontSize: "12px", color: "#555", display: "block", marginTop: "8px" }}>
            Shipping Charges: ₹70/kg within Hyderabad <br />
            ₹150/kg for other cities.

          </small>


          {/* <div style={{ display: "flex", justifyContent: "space-between" }}>
  <strong>Domestic Charges:</strong>
  <span>₹{locationCharge}</span>
</div> */}
          <hr />
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: '18px', fontWeight: 'bold' }}>
            <span>Total:</span>
            <span>₹{grandTotal.toFixed(0)}</span>
          </div>

        </div>
      </div>
      {isModalOpen && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999
        }}>
          <div style={{
            background: "#fff",
            width: "90%",
            maxWidth: "500px",
            borderRadius: "10px",
            padding: "25px",
            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.2)",
            maxHeight: "80vh",
            overflowY: "auto"
          }}>
            <h3 style={{ marginBottom: "20px", color: "#0357a0", textAlign: "center" }}>Select Delivery Address</h3>

            {userAddresses.length === 0 ? (
              <p style={{ textAlign: "center" }}>No saved addresses found.</p>
            ) : (
              userAddresses.map((addr) => (
                <div
                  key={addr.id}
                  onClick={() => {
                    setAddress((prev) => ({
                      ...prev,
                      house: addr.line1,
                      landmark: addr.line2 || "",
                      city: addr.city,
                      pincode: addr.zip,
                    }));
                    setSelectedAddrId(addr.id);
                    setIsModalOpen(false);
                  }}
                  style={{
                    padding: "15px",
                    marginBottom: "12px",
                    border: `2px solid ${selectedAddrId === addr.id ? "#0357a0" : "#eee"}`,
                    borderRadius: "8px",
                    cursor: "pointer",
                    background: selectedAddrId === addr.id ? "#fdf3f4" : "#f9f9f9",
                    transition: "all 0.3s ease",
                  }}
                >
                  <p style={{ margin: 0, fontWeight: "bold" }}>{addr.line1}, {addr.city}</p>
                  <p style={{ margin: 0 }}>{addr.line2}</p>
                  <p style={{ margin: 0 }}>Pincode: {addr.zip}</p>
                </div>
              ))
            )}

            <button
              onClick={() => setIsModalOpen(false)}
              style={{
                marginTop: "20px",
                width: "100%",
                padding: "12px",
                background: "#ccc",
                color: "#333",
                border: "none",
                borderRadius: "8px",
                fontWeight: "bold",
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}

    </div>
  );
};

export default Checkout;
